module.exports = __webpack_public_path__ + "img/tjtb_1.a2166afe.png";